"use strict";

exports.__esModule = true;
exports.AdvancedStripeChartElement = void 0;
var _react = _interopRequireDefault(require("react"));
var _libTimeline = require("@vimana/lib-timeline");
var _styledComponents = require("styled-components");
var _AdvancedStripeChartDataProvider = require("./AdvancedStripeChartDataProvider");
var _StripeChart = require("../../Charts/StripeChart");
var _Core = require("../../Core");
var _getLabel2 = require("./getLabel");
var _PlantStateActivitiesContext = require("../../PlantStateActivities/PlantStateActivitiesContext");
var _common = require("../../ConfigurableLayout/common");
var _Metrics = require("../../../Catalogs/Metrics");
var _TimeContext = require("../../Time/TimeContext");
var _TimelineSubscription = require("../../Timeline/TimelineSubscription");
var _Device = require("../../Device");
var _PlantStateActivities = require("../../PlantStateActivities");
var _timeDefinitions = require("../../timeDefinitions");
var _ChartCard = require("../common/ChartCard");
var _excluded = ["theme"],
  _excluded2 = ["dataRange", "showTickets", "showComments", "showAlerts", "colorSource", "backgroundColor", "gridRowStart", "gridRowEnd", "gridColumnStart", "gridColumnEnd", "widgets", "dimensions", "labelColor", "labels", "columnLabel", "hideXAxis"];
/* eslint-disable no-unused-vars */
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
// Band colour when no colour source applies and the saved default is the
// legacy black canvas colour.
var NEUTRAL_BAND_COLOR = "#C7CFD5";
var updateTimeline = (0, _libTimeline.createTimelineModifier)({
  minimumDuration: 10
});
function _renderTooltip(labels, plantStateActivities, theme, doc) {
  if (doc === void 0) {
    doc = {};
  }
  var labelList = (0, _getLabel2.getLabel)(labels, doc);
  var marginBottom = labelList.length > 1 ? "5px" : "none";
  var borderBottom = labelList.length > 1 ? "1px solid " + theme.TooltipContentBorderBottomColor : "none";
  return labelList.map(function (label, index) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: "Tooltip." + label,
      style: {
        borderBottom: index !== labelList.length - 1 ? borderBottom : "none",
        color: "" + theme.TooltipContentColor,
        marginBottom: marginBottom,
        width: "max-content",
        maxWidth: "200px"
      }
    }, label);
  });
}
var AdvancedStripeChartElement = exports.AdvancedStripeChartElement = (0, _styledComponents.withTheme)(function (_ref) {
  var theme = _ref.theme,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  var dataRange = props.dataRange,
    showTickets = props.showTickets,
    showComments = props.showComments,
    showAlerts = props.showAlerts,
    colorSource = props.colorSource,
    backgroundColor = props.backgroundColor,
    gridRowStart = props.gridRowStart,
    gridRowEnd = props.gridRowEnd,
    gridColumnStart = props.gridColumnStart,
    gridColumnEnd = props.gridColumnEnd,
    widgets = props.widgets,
    dimensions = props.dimensions,
    labelColor = props.labelColor,
    labels = props.labels,
    columnLabel = props.columnLabel,
    hideXAxis = props.hideXAxis,
    extraProps = _objectWithoutPropertiesLoose(props, _excluded2);
  var selectionContext = _react["default"].useContext(_Core.SelectionContext);
  var selection = selectionContext.selected,
    setSelection = selectionContext.setSelection,
    resetSelection = selectionContext.resetSelection;
  var plantStateActivities = (0, _PlantStateActivities.getEnabledPlantStateActivities)(_react["default"].useContext(_PlantStateActivitiesContext.PlantStateActivitiesContext));
  var _React$useContext = _react["default"].useContext(_TimeContext.TimeContext),
    currentWorkday = _React$useContext.currentWorkday,
    currentShift = _React$useContext.currentShift;
  var device = _react["default"].useContext(_Device.DeviceContext);
  var urlFilter = _react["default"].useContext(_Core.URLFilterContext);
  var canBrush = extraProps && extraProps.showBrush;
  var path = extraProps.path;
  var componentPath = (0, _common.getComponentPath)(path);
  var getAlpha = (0, _StripeChart.getAlphaBasedOnSelectionContext)({
    dataRange: dataRange,
    selectionContext: selectionContext,
    valueKey: "dimensions"
  });
  return /*#__PURE__*/_react["default"].createElement(_AdvancedStripeChartDataProvider.AdvancedStripeChartDataProvider, props, function (_ref2) {
    var content = _ref2.content,
      interval = _ref2.interval,
      instantaneousEventList = _ref2.instantaneousEventList;
    if (canBrush && selection && selection.reportingPeriod) {
      extraProps.brushInterval = selection.reportingPeriod.interval;
      extraProps.brushEnableSnapToMillis = true;
      extraProps.brushSnapToMillis = (0, _timeDefinitions.getMinutesMillis)(15);
    }
    var getStripeChart = function getStripeChart(timelineIntervalList) {
      return /*#__PURE__*/_react["default"].createElement(_Device.DeviceTimelineColorController, {
        backgroundColorSource: props.backgroundColorSource,
        getLabel: function getLabel(doc) {
          return (0, _getLabel2.getLabel)(labels, doc)[0];
        },
        realtime: true,
        deviceUuid: device.uuid,
        defaultColor: theme.uiModern && (0, _ChartCard.isLegacyDarkBackground)(backgroundColor) ? NEUTRAL_BAND_COLOR : backgroundColor
      }, function (_ref3) {
        var getBgColor = _ref3.backgroundColor;
        var isEmpty = !timelineIntervalList || timelineIntervalList.length === 0;
        var chart = /*#__PURE__*/_react["default"].createElement(_StripeChart.StripeChart, _extends({}, extraProps, {
          timeline: timelineIntervalList,
          interval: interval,
          showBrush: canBrush,
          getColor: getBgColor,
          getAlpha: getAlpha,
          onBrushChange: function onBrushChange(brushInterval) {
            if (canBrush) {
              setSelection({
                reportingPeriod: {
                  interval: brushInterval
                }
              }, componentPath);
            }
          },
          onBrushReset: function onBrushReset() {
            return resetSelection();
          },
          getLabel: function getLabel(doc) {
            return (0, _getLabel2.getLabel)(labels, doc)[0];
          },
          getLabelColor: function getLabelColor() {
            return labelColor;
          },
          instantaneousEventList: instantaneousEventList,
          axis: !hideXAxis,
          renderTooltip: function renderTooltip(doc) {
            return _renderTooltip(labels, plantStateActivities, theme, doc);
          }
        }));
        // Legacy renders the chart bare; modern can sit a note over it.
        if (!theme.uiModern) {
          return chart;
        }
        return /*#__PURE__*/_react["default"].createElement("div", {
          style: {
            position: "relative"
          }
        }, chart, isEmpty && /*#__PURE__*/_react["default"].createElement(_ChartCard.EmptyTimelineNote, {
          height: extraProps.height
        }));
      });
    };
    var deviceList = (0, _Device.getSelectedDevices)({
      urlFilter: urlFilter,
      dataRange: dataRange,
      selection: selectionContext,
      deviceContext: device
    });
    if ((0, _Metrics.canSubscribeToRealtime)(currentWorkday.interval, currentShift.interval, interval) && deviceList && deviceList[0]) {
      return /*#__PURE__*/_react["default"].createElement(_TimelineSubscription.AdvancedTimelineSubscription, {
        device: deviceList[0],
        timeline: extraProps.timeline
      }, function (latestTimelineVal) {
        if (!latestTimelineVal) {
          return getStripeChart((0, _libTimeline.sliceTimeline)(content, interval));
        }
        var updatedTimeline = updateTimeline(content, Object.assign({}, latestTimelineVal, {
          interval: {
            startMillis: new Date(latestTimelineVal.timestamp).valueOf(),
            endMillis: new Date(latestTimelineVal.timestamp_end).valueOf()
          }
        }));
        return getStripeChart((0, _libTimeline.sliceTimeline)(updatedTimeline, interval));
      });
    }
    return getStripeChart((0, _libTimeline.sliceTimeline)(content, interval));
  });
});